import { VectorUtils } from "../../Utils/VectorUtils.js";
import { SingleLine } from "../Primitive/SingleLine.js";
import { CalibrationShapeBase } from "./CalibrationShapeBase.js";
import { CalibrationMode } from "./CalibrationTool.js";
import { Config } from "../../Config/Config.js";
/**
 * Create a line registering 2 points. Used to calibrate.
 */
export class CalibrationLine extends CalibrationShapeBase {
    constructor(viewType) {
        super(viewType);
        this.mode = CalibrationMode.line;
        this.pointsToRegister = 2;
        this._quotaLineLength = 5;
        this._quotaLineA = new SingleLine("Quota line A", Config.calibrationTool_colorHex);
        this._quotaLineB = new SingleLine("Quota line B", Config.calibrationTool_colorHex);
        this.add(this._quotaLineA, this._quotaLineB);
        this._quotaLineA.bindProperty("visible", (m) => { return !m[this._isRegisteringClickKey]; }, [this._isRegisteringClickKey]);
        this._quotaLineB.bindProperty("visible", (m) => { return !m[this._isRegisteringClickKey]; }, [this._isRegisteringClickKey]);
    }
    update() {
        const perpAB = VectorUtils.getPerpendicularByPoints(this.A.position, this.B.position).setLength(this._quotaLineLength / 2);
        this._quotaLineA.setAB(this._quotaLineA.A.copy(this.A.position).add(perpAB), this._quotaLineA.B.copy(this.A.position).sub(perpAB));
        this._quotaLineB.setAB(this._quotaLineB.A.copy(this.B.position).add(perpAB), this._quotaLineB.B.copy(this.B.position).sub(perpAB));
        this._shape.setGeoPoints([this.A.position, this.B.position]);
    }
    onRegSuccess(points) {
        this.A.position.copy(points[0].setZ(0));
        this.B.position.copy(points[1].setZ(0));
        this.C.position.copy(points[0].lerp(points[1], 0.5));
        this.update();
    }
    onRegMove(point) {
        if (this._registeredPoints.length === 1) {
            this._shape.updateGeoPoints([this._registeredPoints[0], point], 1);
        }
    }
}
//# sourceMappingURL=CalibrationLine.js.map